export default function permission (state = {}, action) {
    switch (action.type) {
        case 'SET_PERMISSION':
            return action.permission;
        default:
            return state;
    }
};